'use client';

import { useStreamHandler } from '@coolblue-development/next-chat/client';
import { Entrance } from '@coolblue-development/next-chatbot-ui/client';
import type { Product } from '@features/product/typings';
import { useTranslation } from '@i18n/useTranslation';
import type { ReactNode } from 'react';

type Props = {
  accountName?: string;
  correlationId: string;
  endpointUrl: string;
  product: Product;
};

const AdviceCues = ({ accountName, correlationId, endpointUrl, product }: Props): ReactNode => {
  const { t } = useTranslation('webshop.productPage');

  const { state, sendUserMessage } = useStreamHandler({
    conversationEndpointUrl: endpointUrl,
    initialState: { uiMessages: [], showError: false },
    correlationId
  });

  return (
    <Entrance
      title={
        accountName
          ? t('adviceCues.title.withName', {
              customerName: accountName,
              productType: product.productType.singularName
            })
          : t('adviceCues.title.withoutName', {
              productType: product.productType.singularName
            })
      }
      state={state}
      onSendMessage={message =>
        sendUserMessage(message, {
          chatSource: 'product_advice_cue_agent',
          clientContext: { productId: String(product.id) }
        })
      }
    />
  );
};

export default AdviceCues;
